import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { firstValueFrom } from 'rxjs';
import { Brand } from '../store/brands/brands.actions';

interface PermissionsResponse {
  brands: Brand[];
  CpnyIDs: string[];
}

@Injectable({
  providedIn: 'root'
})
export class BrandsService {

  constructor(private rest: RestService) { }

  async getBrands(): Promise<Brand[]> {
    try {
      const response = await firstValueFrom(this.rest.get('/brand-branch/brand-lite'));
      return response;
    } catch (error) {
      console.error('Error al obtener las marcas:', error);
      throw error;
    }
  }

  async getUserPermissions(): Promise<PermissionsResponse> {
    try {
      const response = await firstValueFrom(this.rest.get('/pedido-amda/search/permisos'));
      return response;
    } catch (error) {
      console.error('Error al obtener permisos del usuario:', error);
      throw error;
    }
  }

  setSelectedBranch(cpnyId: string): void {
    localStorage.setItem('selectedCpnyID', cpnyId);
  }

  getSelectedBranch(): string | null {
    return localStorage.getItem('selectedCpnyID');
  }

  clearSelectedBranch(): void {
    localStorage.removeItem('selectedCpnyID');
  }
}
